/* eslint-disable camelcase, react/jsx-pascal-case */
import SelectBox_Option_SingleLine from './selectBox_Option_SingleLine';

export default SelectBox_Option_SingleLine;
